"use client";

import React from "react";
import {Accordion, AccordionDetails, AccordionSummary, Box, Typography} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface FilterBoxProps {
  name: string;
  children: React.ReactNode;
  sx?: object;
}

const FilterBox: React.FC<FilterBoxProps> = ({ name, children, sx }) => (
  <Box sx={{ borderTop: (theme) => `1px solid ${theme.palette.divider}`, mb:"1.6rem", ...sx }}>
    <Accordion defaultExpanded
      sx={{
        width: "100%",
        boxShadow: 0,
        background: "transparent",
        display: "flex",
        flexDirection: "column",
        alignSelf: "stretch"
      }}
    > 
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id={`${name}_panel1-header`}
        data-testid={`${name}_accordion-summary`}
        sx={{
          margin: "0 0",
          minHeight: "unset",
          padding: "unset",
          paddingBottom: 0,
          "&.MuiAccordionSummary-root": { minHeight: "unset" },
          "& .MuiAccordionSummary-content": { margin: "0 !important" }
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column",width: {
            xs: "100%", // Mobile - full width
            legacyTablet: "100%", // Tablet - full width  
            legacyDesktop: "100%" // Desktop - fixed width
          } }}>
          <Typography
            sx={{
              textTransform: "uppercase",
              my: "1.2rem",
              fontSize: "1.8rem",
              fontWeight: 600
          }}
            data-testid={`${name}_filter-section-label`}
          >
            {name}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ marginTop: "-.75rem", padding: "0" }}>{children}</AccordionDetails>
    </Accordion>
  </Box>
);

export default FilterBox;

